var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container horizontal"},[_c('ItemList',{attrs:{"itemID":_vm.itemID,"headless":true,"childFilter":"taskLike"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }